"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeKeyType = exports.AttributeSupportedResourceType = void 0;
/**
 * Resources within the Transcend dashboard that support the attributes feature
 */
var AttributeSupportedResourceType;
(function (AttributeSupportedResourceType) {
    /** Action items table */
    AttributeSupportedResourceType["ActionItem"] = "actionItem";
    /** Airgap Cookie tabs */
    AttributeSupportedResourceType["AirgapCookie"] = "airgapCookie";
    /** Airgap Data Flow tabs */
    AttributeSupportedResourceType["AirgapDataFlow"] = "airgapDataFlow";
    /** AssessmentForm table */
    AttributeSupportedResourceType["AssessmentForm"] = "assessmentForm";
    /** AssessmentGroup table */
    AttributeSupportedResourceType["AssessmentGroup"] = "assessmentGroup";
    /** AuditorRun table */
    AttributeSupportedResourceType["AuditorRun"] = "auditorRun";
    /** AuditorSchedule table */
    AttributeSupportedResourceType["AuditorSchedule"] = "auditorSchedule";
    /** Business entity table */
    AttributeSupportedResourceType["BusinessEntity"] = "businessEntity";
    /** Categories table */
    AttributeSupportedResourceType["DataSubCategory"] = "dataSubCategory";
    /** Datapoint table */
    AttributeSupportedResourceType["DataPoint"] = "dataPoint";
    /** Datapoint level table */
    AttributeSupportedResourceType["DataPointLevel"] = "dataPointLevel";
    /** Data silos table */
    AttributeSupportedResourceType["DataSilo"] = "dataSilo";
    /** Enricher table */
    AttributeSupportedResourceType["Enricher"] = "enricher";
    /** Identifier table */
    AttributeSupportedResourceType["Identifier"] = "identifier";
    /** LegalHold table */
    AttributeSupportedResourceType["LegalHold"] = "legalHold";
    /** LegalMatter table */
    AttributeSupportedResourceType["LegalMatter"] = "legalMatter";
    /** Processing activity table */
    AttributeSupportedResourceType["ProcessingActivity"] = "processingActivity";
    /** Processing purpose table */
    AttributeSupportedResourceType["ProcessingPurposeSubCategory"] = "processingPurposeSubCategory";
    /** Prompt table */
    AttributeSupportedResourceType["Prompt"] = "prompt";
    /** PromptGroup table */
    AttributeSupportedResourceType["PromptGroup"] = "promptGroup";
    /** PromptRun table */
    AttributeSupportedResourceType["PromptRun"] = "promptRun";
    /** Requests table */
    AttributeSupportedResourceType["Request"] = "request";
    /** ScannedObject table */
    AttributeSupportedResourceType["ScannedObject"] = "scannedObject";
    /** ScannedObjectPath table */
    AttributeSupportedResourceType["ScannedObjectPath"] = "scannedObjectPath";
    /** Subject table */
    AttributeSupportedResourceType["Subject"] = "subject";
    /** Subdatapoints table (shows up under Data Inventory > Data Points tab) */
    AttributeSupportedResourceType["SubDataPoint"] = "subDataPoint";
    /** Vendor table */
    AttributeSupportedResourceType["Vendor"] = "vendor";
})(AttributeSupportedResourceType || (exports.AttributeSupportedResourceType = AttributeSupportedResourceType = {}));
/**
 * Types for attribute keys
 */
var AttributeKeyType;
(function (AttributeKeyType) {
    /** Multiple attribute values from this attribute key can be assigned to a resource */
    AttributeKeyType["MultiSelect"] = "MULTI_SELECT";
    /** Only a single attribute value from this attribute key can be assigned to a resource */
    AttributeKeyType["SingleSelect"] = "SINGLE_SELECT";
    /** Text-based attribute */
    AttributeKeyType["Text"] = "TEXT";
    /** Email-based attribute */
    AttributeKeyType["EMAIL"] = "EMAIL";
    /** Phone-based attribute */
    AttributeKeyType["TELEPHONE"] = "TELEPHONE";
    /** URL-based attribute */
    AttributeKeyType["URL"] = "URL";
    /** Assessment attribute */
    AttributeKeyType["Assessment"] = "ASSESSMENT";
})(AttributeKeyType || (exports.AttributeKeyType = AttributeKeyType = {}));
//# sourceMappingURL=attribute.js.map